import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const FundingSplitChart = ({
  privatePercentage = 60,
  governmentPercentage = 40,
}) => {
  const data = [
    { name: "Private Sector", value: privatePercentage, color: "#4FAD5B" },
    { name: "Government", value: governmentPercentage, color: "#0092CC" },
  ];

  const renderLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    value,
  }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="#050505"
        textAnchor="middle"
        dominantBaseline="central"
        fontSize="0.70581rem"
        fontWeight="500"
        fontFamily="Inter"
        fontStyle="normal"
        style={{ lineHeight: "0.88225rem" }}
      >
        {`${value}%`}
      </text>
    );
  };

  const renderLegend = (props) => {
    const { payload } = props;
    return (
      <div className="mt-[1.25rem] flex items-center gap-[1rem]">
        {payload?.map((entry, index) => (
          <div key={`legend-${index}`} className="flex items-center gap-[5px]">
            <div
              className="w-3 h-3 rounded-full"
              style={{ backgroundColor: entry?.color }}
            ></div>
            <span className="text-sm text-gray-600">{entry?.name}</span>
          </div>
        ))}
      </div>
    );
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white px-3 py-2 border border-gray-200 rounded shadow-lg">
          <p className="text-sm font-medium text-gray-900">{payload[0].name}</p>
          <p className="text-sm text-gray-600">{`${payload[0].value}%`}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="w-full flex items-center flex-col">
      <div className="text-[#424242] font-sora text-[.875rem] font-[400] leading-[1.5rem]">
        Funding Split
      </div>
      <ResponsiveContainer width="100%" height={200}>
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={40}
            outerRadius={90}
            paddingAngle={0}
            dataKey="value"
            startAngle={90}
            endAngle={450}
            label={renderLabel}
            labelLine={false}
          >
            {data?.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry?.color} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
        </PieChart>
      </ResponsiveContainer>
      {renderLegend({ payload: data })}
    </div>
  );
};

export default FundingSplitChart;
